import { IShipment } from '../components/Applications/Intransit/interfaces'
import {
    IFetchShipmentCurrrentLocationsResponse,
    IAllShipmentsQueryParam,
} from './apiInterfaces'
import { makeRequest } from './dtServices'

export const fetchAllShipmentLocations = async (
    params: IAllShipmentsQueryParam,
): Promise<IShipment[]> => {
    const response = await makeRequest<
        IFetchShipmentCurrrentLocationsResponse,
        IAllShipmentsQueryParam
    >('post', `/coldChain`, params)
    return response?.shipments ?? []
}
